var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WorkBenchSequenceWaggon',{attrs:{"height":"calc(100% - 350px - 48px)"},scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c('Activator',{key:"nowaggonsactivtor",staticClass:"self-centered cursor-s-resize",nativeOn:{"click":function($event){return _vm.$router.push({
          name: `${_vm.location}SequenceEditor`
        })}}})]},proxy:true},{key:"tabs",fn:function(){return [_c('draggable',{staticClass:"display-flex",style:(_vm.$route.matched[3].name === 'WorkBenchSequenceWaggonWorkPackageAdd'?
        `width: calc(${_vm.waggon[`${_vm.prefix}sworkpackages`].length} * 100px)`:'width: 100%'),attrs:{"animation":"300","forceFallback":"true","fallbackOnBody":"true","value":_vm.waggon[`${_vm.prefix}sworkpackages`],"disabled":_vm.read_only},on:{"input":function($event){_vm.create?
        _vm.updateWBLObject({
          path: [
          {sequence: ''},
          {swaggons: _vm.waggon_id},
          {sworkpackages: ''}
          ],
          update: $event,
          })
        :
        ''},"end":function($event){_vm.create?
      _vm.$router.push({
        name: `${_vm.location}SequenceWaggonWorkPackage`,
        params: {work_package_id: $event.newIndex}
        })
      :
      _vm.changeWBObjectPosition({
        url: [
          {[`${_vm.prefix}sequences`]: _vm.sequence_id},
          {[`${_vm.prefix}swaggons`]: _vm.waggon_id},
          {[`${_vm.prefix}sworkpackages`]: _vm.waggon[`${_vm.prefix}sworkpackages`][$event.oldIndex]},
          {pushpositions: ''}
        ],
        target: {
          target_id: _vm.waggon[`${_vm.prefix}sworkpackages`][$event.newIndex],
        }
        })}}},_vm._l((_vm.create?_vm.waggon[`${_vm.prefix}sworkpackages`]:_vm.getWBObjects({type: `${_vm.prefix}sworkpackages`, ids: _vm.waggon[`${_vm.prefix}sworkpackages`]})),function(workpackage,index){return _c('WorkBenchSequenceWaggonTab',{key:_vm.create?index:workpackage.id,class:`${_vm.read_only?'cursor-pointer':'cursor-grab mr-1'}`,attrs:{"color":workpackage.color,"text_color":workpackage.textcolor,"token":workpackage.token,"icon":workpackage.icon,"selected":_vm.create?(index === _vm.$route.params.workpackage_id):(workpackage.id === _vm.$route.params.workpackage_id),"width":_vm.create?((index === _vm.$route.params.workpackage_id)? `calc(100% - ${_vm.waggon[`${_vm.prefix}sworkpackages`].length-2} * 100px)`:'100px'):((workpackage.id === _vm.$route.params.workpackage_id)?`calc(100% - ${_vm.waggon[`${_vm.prefix}sworkpackages`].length-2} * 100px)`:'100px')},nativeOn:{"click":function($event){return _vm.routeToWaggonWorkPackage(index, workpackage)}},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',[_vm._v(_vm._s(workpackage.token)+" "+_vm._s((_vm.create?index:workpackage.id) === _vm.$route.params.workpackage_id?`- ${workpackage.name}`:''))])]},proxy:true},((_vm.create?index:workpackage.id) === _vm.$route.params.workpackage_id)?{key:"actions",fn:function(){return [(!_vm.read_only)?_c('StandardDeleteButton',{attrs:{"zoom":1},on:{"clickDelete":function($event){_vm.create?
            (_vm.$router.push({
                  name: _vm.waggon[`${_vm.prefix}sworkpackages`].length > 1?
                    `${_vm.location}SequenceWaggonWorkPackage`:
                    `${_vm.location}SequenceWaggonWorkPackageAdd`,
                  params: _vm.waggon[`${_vm.prefix}sworkpackages`].length > 1?
                  {
                    work_package_id: index === 0?0:index-1
                  }:{}
                }),
              _vm.deleteWBLObject({
                path: [
                  {sequence: ''},
                  {swaggons: _vm.waggon_id},
                  {sworkpackages: ''}
                ],
                index: index
              }))
              :
              (_vm.$router.push({
                  name: _vm.waggon[`${_vm.prefix}sworkpackages`].length > 1?
                    `${_vm.location}SequenceWaggonWorkPackage`:
                    `${_vm.location}SequenceWaggonWorkPackageAdd`,
                  params: _vm.waggon[`${_vm.prefix}sworkpackages`].length > 1?
                  {
                    work_package_id: index === 0?
                      _vm.waggon[`${_vm.prefix}sworkpackages`][1]:
                      _vm.waggon[`${_vm.prefix}sworkpackages`][index-1]
                  }:{}
                }),
              _vm.deleteWBObject({
                url: [
                  {[`${_vm.prefix}sequences`]: _vm.sequence_id},
                  {[`${_vm.prefix}swaggons`]: _vm.waggon_id},
                  {[`${_vm.prefix}sworkpackages`]: workpackage.id}
                ]
              }))}}}):_vm._e(),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [(!_vm.read_only)?_c('v-btn',_vm._g(_vm._b({attrs:{"icon":"","small":"","color":workpackage.textcolor},on:{"click":function($event){return _vm.$router.push({
                    name: `${_vm.location}SequenceWaggonWorkPackageEditor`,
                    params: {
                      editor_work_package_id: _vm.create?index:workpackage.id
                    }
                  })}}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"small":""}},[_vm._v("edit")])],1):_vm._e()]}}],null,true)},[_c('span',[_vm._v(_vm._s(_vm.$t('WorkBench.Editor.Sequence.Workpackage.edit')))])]),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":"","small":"","color":workpackage.textcolor},on:{"click":function($event){$event.stopPropagation();_vm.getNestedWorkPackageCreate(workpackage, true).then(work_package => {
                  _vm.updateWBLObject({
                    path: [
                    {workpackage: ''}
                    ],
                    update: work_package
                    }),
                    _vm.$router.push({
                     name: `WorkBenchSequenceWaggonWorkPackageAddWorkPackageEditor`,
                     params: {
                       workpackage_id: 'create',
                     }
                   })
                  })}}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"small":""}},[_vm._v("content_copy")])],1)]}}],null,true)},[_c('span',[_vm._v(_vm._s(_vm.$t('WorkBench.Editor.Sequence.Workpackage.copy')))])]),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":"","small":"","color":workpackage.textcolor},on:{"click":function($event){$event.stopPropagation();_vm.getNestedWorkPackageCreate(workpackage, false).then(work_package => {
                  _vm.updateWBLObject({
                    path: [
                    {workpackage: ''}
                    ],
                    update: work_package
                    }),
                    _vm.$router.push({
                     name: `WorkBenchSequenceWaggonWorkPackageAddWorkPackageEditor`,
                     params: {
                       workpackage_id: 'create',
                     }
                   })
                  })}}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"small":""}},[_vm._v("file_copy")])],1)]}}],null,true)},[_c('span',[_vm._v(_vm._s(_vm.$t('WorkBench.Editor.Sequence.Workpackage.copyWithoutSteps')))])])]},proxy:true}:null],null,true)})}),1),(!_vm.read_only)?_c('WorkBenchSequenceWaggonTab',{attrs:{"color":`${_vm.$vuetify.theme.isDark ? 'grey darken-3' : 'grey lighten-3'} cursor-pointer`,"text_color":_vm.$vuetify.theme.isDark ? 'white' : 'black',"icon":"sign-plus","width":_vm.$route.matched[3].name === `${_vm.location}SequenceWaggonWorkPackageAdd`?`calc(100% - ${_vm.waggon[`${_vm.prefix}sworkpackages`].length-2} * 100px)`:'100px'},nativeOn:{"click":function($event){_vm.$route.name !== `${_vm.location}SequenceWaggonWorkPackageAdd`?
        _vm.$router.push({
          name: `${_vm.location}SequenceWaggonWorkPackageAdd`
        }):''}},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('TText',{staticStyle:{"align-self":"center"},attrs:{"value":"add"}})]},proxy:true},(_vm.$route.matched[3].name === `${_vm.location}SequenceWaggonWorkPackageAdd`)?{key:"actions",fn:function(){return [_c('StandardDataField',{attrs:{"icon":"search","append_icon":"clear","text_color":"white","one_liner":true,"value":_vm.getWBLObject({
            path: [
              {sequence_editor_variables: ''},
              {search: ''},
            ]
          })},on:{"inputValue":function($event){return _vm.updateWBLObject({
            path: [
              {sequence_editor_variables: ''},
            ],
            update: {
              search: $event
            }
          })},"clickAppendIcon":function($event){return _vm.updateWBLObject({
            path: [
              {sequence_editor_variables: ''},
            ],
            update: {
              search: ''
            }
          })}}})]},proxy:true}:null],null,true)}):_vm._e()]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }